import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { DateInput as ArcDateInput, DateInputProps } from 'arc';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export const DateInput = forwardRef<HTMLDivElement, DateInputProps>(function DateInput(props, ref) {
    const { datePickerForceLeadingZerosEnabled } = useEnabledFeatures();
    return (
        <ArcDateInput
            ref={ref}
            {...props}
            shouldForceLeadingZeros={props.shouldForceLeadingZeros || datePickerForceLeadingZerosEnabled}
        />
    );
});
